
<div class="mainDiv">

    <div class="paymentMethod">

        <div class="paymentMethodTitle">
            <h5>Moduli</h5>
            <button 
            type="button" 
            class="buttonReturnToModules"
            (click)="goToModulePayment()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                </svg>
                TORNA AI MODULI
            </button>
        </div>
        <div class="paymentMethodBody">

              <mat-accordion>

                  <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header>
                      <mat-panel-title></mat-panel-title>
                      <mat-panel-description> Paga con Nexi XPay </mat-panel-description>
                    </mat-expansion-panel-header>
                  
                    <div class="nexi-payment-container">
                      <button type="button" class="payButton" (click)="startPayment()">
                        <img src="../../../../assets/nexi/xpayPrimary.svg" alt="Paga con Nexi XPay" style="height: 40px;">
                      </button>
                    </div>
                  </mat-expansion-panel>
                  
              </mat-accordion>
        </div>
    </div>
    <div class="store">
            <!-- GRAFICA DEL CARRELLO -->
            <div class="storeTitle">
                <h5>Carrello</h5>
            </div>
    
            <div class="storeBody">
                <div class="header">
                    <div style="width: 20%"></div>
                    <div style="width: 60%"><b>MODULO SELEZIONATO:</b></div>
                    <div style="width: 20%; text-align: right;"><b>PREZZO:</b></div>
                </div>
                <div class="body">
                    <div *ngFor="let item of cart" class="item">
                        <div style="width: 20%">
                            <button type="button"
                                class="buttonDelete"
                                (click)="removeModule(item.id)" 
                                [title]="'grid.button.deleteRecord' | transloco" 
                                kendoButton [svgIcon]="deleteSVG">
                            </button>
                        </div>
                        <div style="width: 60%">{{item.title}}</div>
                        <div style="width: 20%; text-align: right;">€ {{ priceFormatter(item.price) }}</div>
                    </div>
                </div>

                <div class="footer">
                    <h5>Prezzo totale (con IVA): €</h5>
                    <h5 type="hidden" name="importo"> {{ priceFormatter(storeAmount(cart)) }}</h5>
                </div>


         </div>
    </div>  
</div>